import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import { withDisplayName } from '@hocs/with-display-name'
import { Entry } from '@resolvers/entry'
import RichText from '@resolvers/rich-text'
import { defaultRichTextFieldOptionsDeprecated } from '@resolvers/rich-text/default-rich-text-field-options-deprecated'
import { contentArticleTitleOptions } from '@rich-text/contentful-content-article-rich-text'
import { CtaLink } from '@ui/cta-link'
import {
  ENHANCED_COMPONENT_ROLE,
  ENHANCED_COMPONENT_TYPE,
} from '@ui/enhanced-components/types'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  objectPosition: 'center',
  alt: '',
}

const ContentfulContentArticleImageLeft: Utils.EntryFC<
  Queries.ContentfulContentArticleImageLeftFragment
> = ({
  content: {
    image,
    contentArticleTitle: title,
    subtitle,
    contentLinkText,
    contentLinkUrl,
  },
  entryInspectorProps,
  fieldInspectorProps,
}) => (
  <div className="w-full px-2 py-4 laptop:py-10" {...entryInspectorProps()}>
    <div
      className="laptop:hidden"
      {...fieldInspectorProps({
        fieldId: 'image',
      })}
    >
      <AssetOptionsContext.Provider value={assetOptions}>
        <Entry
          content={image}
          mapping={{
            [ContentType.ContentfulAsset]: ContentfulAsset,
          }}
        />
      </AssetOptionsContext.Provider>
    </div>
    <div className="pb-0 pt-2">
      <RichText
        {...fieldInspectorProps({
          fieldId: 'title',
        })}
        content={title}
        options={contentArticleTitleOptions}
      />
    </div>
    <div className="pb-4 pt-1">
      <RichText
        {...fieldInspectorProps({
          fieldId: 'subtitle',
        })}
        content={subtitle}
        options={defaultRichTextFieldOptionsDeprecated}
      />
    </div>
    <CtaLink
      data-role={ENHANCED_COMPONENT_ROLE.SECONDARY}
      data-type={ENHANCED_COMPONENT_TYPE.CTA}
      href={contentLinkUrl}
      {...fieldInspectorProps({
        fieldId: 'contentLinkText',
      })}
    >
      {contentLinkText}
    </CtaLink>
  </div>
)

export const query = graphql`
  fragment ContentfulContentArticleImageLeft on Contentful4TmD9EihHakmKMkEwKaUwQ {
    ...ContentfulEntry
    contentArticleTitle: title {
      ...ContentfulContentArticleTitle
    }
    subtitle {
      ...ContentfulContentArticleSubtitle
    }
    image {
      ...ContentfulDefaultAsset
    }
    contentLinkText
    contentLinkUrl
  }
`

export default withDisplayName(
  ContentfulContentArticleImageLeft,
  'ContentfulContentArticleImageLeft'
)
